import {BackendApi} from "../../../../../api/api.ts";
import {
    CreateRecurringSeriesRequest,
    RecurringSeriesDetails,
} from "./types/recurringInvoice.ts";
import type {PaymentTerm, RecurringCadence} from "../../../../../generated/enums.ts";

export async function listRecurringSeries(api: BackendApi): Promise<RecurringSeriesDetails[]> {
    const response = await api.Me__business__getRecurringSalesInvoices({})
    return response.series
}

export async function createRecurringSeries(
    api: BackendApi,
    request: CreateRecurringSeriesRequest,
): Promise<RecurringSeriesDetails> {
    return await api.Me__business__createRecurringSalesInvoice(request)
}

export async function changeRecurringSeries(
    api: BackendApi,
    seriesId: string,
    changes: {
        cadence?: RecurringCadence,
        description?: string,
        paymentTerm?: PaymentTerm,
        autoSend?: boolean,
    },
): Promise<RecurringSeriesDetails> {
    return await api.Me__business__changeRecurringSalesInvoice({
        series_id: seriesId,
        cadence: changes.cadence ?? null,
        description: changes.description ?? null,
        payment_term: changes.paymentTerm ?? null,
        auto_send: changes.autoSend ?? null,
    })
}

export async function setRecurringSeriesActive(
    api: BackendApi,
    seriesId: string,
    isActive: boolean,
): Promise<RecurringSeriesDetails> {
    return isActive
        ? await api.Me__business__resumeRecurringSalesInvoice({series_id: seriesId})
        : await api.Me__business__pauseRecurringSalesInvoice({series_id: seriesId})
}

export async function deleteRecurringSeries(api: BackendApi, seriesId: string): Promise<void> {
    await api.Me__business__deleteRecurringSalesInvoice({series_id: seriesId})
}
